import { Card, Loading } from '@sede-enterprise/shell-ds-react-framework'
import React from 'react'
import Plot from 'react-plotly.js'
import { transformDataForChart } from './utils/statsUtil';
import useFetchSensorCmlCount from './hooks/useFetchSensorCmlCount';
import { siteMapping } from '../../util/helperFunctions';


const AdminView = ({ ratingsData }) => {

    const { Count, loading } = useFetchSensorCmlCount();
    const { siteIds, sensorCounts, cmlCounts } = transformDataForChart(Count);

    return (
        <div className='parent-container'>
            <div className='content-container'>
                <div className='content-header'>
                    <h2>Admin View</h2>
                </div>
                <div className='content-body'>
                    <div className='admin-cards-container'>
                        <Card bodyPadding={false} className='admin-sensor-ratings'>
                            <h4>Sensor Ratings</h4>
                            <Plot
                                useResizeHandler={true}
                                data={[
                                    {
                                        labels: ['GOOD', 'FAIR', 'POOR', 'NA'],
                                        values: [ratingsData.greenCount, ratingsData.amberCount, ratingsData.redCount, ratingsData.neutralCount],
                                        type: 'pie',
                                        hole: 0.5,
                                        textposition: 'outside',
                                        automargin: true,
                                        textinfo: "label+value",
                                        hoverinfo: "none",
                                        marker: {
                                            colors: ['#197647', '#fbcf09', '#d93638', '#d3d3d3'],
                                        },
                                    }
                                ]}
                                config={{ displayModeBar: false }}
                                layout={{
                                    legend: {
                                        itemclick: false,
                                        itemdoubleclick: false
                                    },
                                    autosize: true,
                                    margin: { t: 20, b: 20 },
                                    height: 350,
                                }}

                            />
                        </Card>

                        <Card bodyPadding={false} className='admin-sensor-ratings'>
                            <h4>CMLs & Installed Sensors on units</h4>
                            {loading && <div className='loading-container' role='status'><Loading /></div>}
                            {!loading && <Plot
                                useResizeHandler={true}
                                data={[
                                    {
                                        x: siteIds.map(siteId => siteMapping(siteId)),
                                        y: sensorCounts,
                                        type: 'scatter',
                                        mode: 'lines+markers+text',
                                        name: 'Sensor Count',
                                        text: sensorCounts,
                                        textposition: 'top',
                                        line: { color: '#fbcf09' }
                                    },
                                    {
                                        x: siteIds.map(siteId => siteMapping(siteId)),
                                        y: cmlCounts,
                                        type: 'scatter',
                                        mode: 'lines+markers+text',
                                        name: 'CML Count',
                                        line: { color: '#d93638' },
                                        text: cmlCounts,
                                        textposition: 'bottom'
                                    }
                                ]}
                                config={{ displayModeBar: false }}
                                layout={{

                                    autosize: true,
                                    margin: { t: 10, b: 90 },
                                    height: 350,
                                }}
                            />}
                        </Card>

                    </div>

                </div>
            </div>

        </div>
    )
}

export default AdminView